export default "__VITE_ASSET__e574f46d__"